import { TPaginationState, TTableState } from '../Components/GenericTable/types';
import { candidatesTableColumn } from './config';
import { TCandidate as BaseTCandidate } from '../Candidates/types';
import { ICandidateGroup } from '../AgenticMatching/types';

export interface ISearchFilter {
  [key: string]: any;
}

export interface ICandidateSourcingSearch {
  id: number;
  query: string;
  filters: ISearchFilter | Record<string, never>;
}

export enum MatchScore {
  POOR = 0,
  GOOD = 1,
  EXCELLENT = 2
}

export interface TCandidate extends BaseTCandidate {
  assessed: boolean;
  matched_condition_ids: number[];
  suitability_comment: string;
  matching_percent: number;
  matching_percent_color: string;
  revealing_contacts?: boolean;
  candidate_group: ICandidateGroup;
  matching_conditions: {
    id: number;
    content: string;
    suitability_comment: string;
    matched_score: MatchScore | null;
  }[];
}

export interface CandidatesState {
  snackbar: {
    message: string;
    state: 'success' | 'warning' | 'error';
  };
  candidatesTableState: TTableState<TCandidate, typeof candidatesTableColumn>;
  candidatesTableSettings: TPaginationState<(typeof candidatesTableColumn)[number]['id']>;
  searchQuery: string;
}

export interface ICableData {
  id: number;
  kind: string;
}
